import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  max-width: 100px;
  margin: auto;
  margin-top: 40vh;
`;
